export default "__VITE_ASSET__DmIgMLqE__ 500w";